module.exports = __webpack_public_path__ + "/login_ui/img/gw-23954d5de711ade45f906c6c435bdd1f.svg";